import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormControl, Validators } from '@angular/forms'
import { Router } from '@angular/router'
import { Store } from '@ngrx/store'
import {
  customEmailValidator,
  handleServerError,
  validateAllFormFields,
} from 'models/form'
import { UserMeUpdateFields } from 'models/hubtype-user'
import { finalize, first } from 'rxjs/operators'
import { CustomError } from 'src/app/constants/errors'
import { FeedbackService } from 'src/app/services/feedback.service'
import * as fromRoot from '../../reducers'
import { UserService } from '../../services/hubtype-api/user.service'

type ProfileFormKeys = keyof Pick<
  UserMeUpdateFields,
  'email' | 'username' | 'first_name' | 'last_name'
>

@Component({
  selector: 'complete-profile',
  templateUrl: 'complete-profile.component.html',
  standalone: false,
})
export class CompleteProfileComponent implements OnInit {
  form = this.fb.nonNullable.group<
    Record<ProfileFormKeys, FormControl<string>>
  >({
    email: new FormControl('', [Validators.required, customEmailValidator()]),
    username: new FormControl(''),
    first_name: new FormControl(''),
    last_name: new FormControl(''),
  })

  isLoading = false

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private store: Store<fromRoot.State>,
    private feedbackService: FeedbackService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.setInitialFormValues()
  }

  onSubmit() {
    if (!validateAllFormFields(this.form)) {
      return
    }

    this.isLoading = true
    this.userService
      .updateUserMe(this.form.value)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: () => {
          this.router.navigate(['desk'])
        },
        error: err => {
          handleServerError({
            error: err,
            form: this.form,
            feedbackService: this.feedbackService,
            customUnhandledError: CustomError.PROFILE_UPDATE,
          })
        },
      })
  }

  private setInitialFormValues() {
    this.store
      .select(fromRoot.getMeState)
      .pipe(first(Boolean))
      .subscribe(me => {
        this.form.patchValue({
          email: me.email,
          username: me.username,
          first_name: me.first_name,
          last_name: me.last_name,
        })
      })
  }
}
